<template>
  <BCollapse
    :id="idName"
    :class="className"
    :visible="open"
    :accordion="accordianName"
    tag="ul"
  >
    <template
      v-for="(item, index) in items"
    >

      <li
        v-if="item?.is_not_visible ? item.is_not_visible : true"
        :key="index"
        :class="[
          item.class_name, {
            'p-0': !hideMenuTitle,
            'iq-menu-title': item.is_heading,
            'active': (activeLink(item) && item.children && item.collapsable) || activeLink(item)
          }
        ]"
      >
        <i
          v-if="item.is_heading && hideMenuTitle"
          class="fad fa-minus"
          style="min-height: 20px;"
        />

        <span
          v-if="item.is_heading && hideMenuTitle"
          v-text="item.title"
        />

        <router-link
          v-if="((item.children && !item.collapsable) || !item.children) && !item.is_heading"
          :to="item.link"
          :class="[
            {
              'active': (item.children && activeLink(item) || !item.collapsable) || activeLink(item)
            }
          ]"
        >
          <i
            v-if="item.is_icon_class"
            :class="activeLink(item) && item.active_icon ? item.active_icon : item.icon"
          />
          <template
            v-else
            v-text="activeLink(item) && item.active_icon ? item.active_icon : item.icon"
          />
          <span v-text="item.title" />
        </router-link>

        <a
          v-if="item.children && item.collapsable && !item.is_heading"
          v-b-toggle="item.name"
          :class="[
            'cursor-pointer',
            item.class_name, {
              active: (activeLink(item) && item.children) || activeLink(item)
            }
          ]"
        >
          <i
            v-if="item.is_icon_class"
            :class="activeLink(item) && item.active_icon ? item.active_icon : item.icon"
          />
          <template
            v-else
            v-text="activeLink(item) && item.active_icon ? item.active_icon : item.icon"
          />
          <span v-text="item.title" />
          <i
            v-if="item.children"
            class="ri-arrow-right-s-line iq-arrow-right"
          />
          <small
            v-if="hideMenuTitle"
            :class="item.append_class"
            v-text="item.append"
          />
        </a>
        <CollapseMenuItem
          v-if="item.children && item.collapsable"
          :id-name="item.name"
          :items="item.children"
          :sidebar-group-title="hideMenuTitle"
          :open="(item.link?.name && activeLink(item) && item.children) ? true : !!(item.link?.name && activeLink(item))"
          :accordian-name="`sidebar-accordion-${item.class_name}`"
          :class-name="['iq-submenu', item.class_name]"
        />
      </li>
    </template>
  </BCollapse>
</template>
<script>
import { core } from '@/config/pluginInit'

import CollapseMenuItem from '@/components/core/menus/CollapseMenu.vue'

export default {
  name: 'CollapseMenuItem',

  components: {
    CollapseMenuItem
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    className: { type: String, default: 'iq-menu' },
    open: { type: Boolean, default: false },
    idName: { type: String, default: 'sidebar' },
    accordianName: { type: String, default: 'sidebar' },
    sidebarGroupTitle: { type: Boolean, default: true }
  },

  computed: {
    hideMenuTitle () {
      return this.sidebarGroupTitle
    }
  },

  methods: {
    activeLink (item) {
      return core.getActiveLink(item, this.$route.name)
    }
  }
}
</script>
